import React, { useEffect, useState } from 'react';
import {back} from './back.js';
import img1 from '../img/Banner3.png'
import carousel1 from '../img/adwordsRes1.png'
import carousel2 from '../img/adwordsRes2.png'
import carousel3 from '../img/adwordsRes3.png'
import carousel4 from '../img/adwordsRes4.png'


import carousel6 from '../img/metaImg1.jpeg'
import carousel7 from '../img/metaImg2.jpeg'
import carousel8 from '../img/metaImg3.jpeg'
import carousel9 from '../img/metaImg4.jpeg'
function Result() { 
  const [magnify,setMagnify] = useState(0);
  return (
    <>
        <div className='result-googleAdwords container-fluid bg-primary bg-opacity-75  text-center pt-5  mb-3'>
        <span className='fw-bolder head1 p-2'>Google Adwords Results</span><br />
                <div className='fw-bolder position-relative head2 mt-2'>WITH 6X+ ROAS+</div>
                <div id="carouselExampleInterval" className="carousel slide" data-bs-ride="carousel">
                    <div className="carousel-inner">
                        <div className="carousel-item active" data-bs-interval="2000">
                            <img src={carousel1} className="d-block w-100" alt="..."/>
                        </div>
                        <div className="carousel-item" data-bs-interval="2000">
                            <img src={carousel2} className="d-block w-100" alt="..."/>
                        </div>
                        <div className="carousel-item">
                            <img src={carousel3} className="d-block w-100" data-bs-interval="2000" alt="..."/>
                        </div>
                        <div className="carousel-item">
                            <img src={carousel4} className="d-block w-100" alt="..."/>
                        </div>
                    </div>
                    <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleInterval" data-bs-slide="prev">
                        <span className="carousel-control-prev-icon bg-dark" aria-hidden="true"></span>
                        <span className="visually-hidden">Previous</span>
                    </button>
                    <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleInterval" data-bs-slide="next">
                        <span className="carousel-control-next-icon bg-dark" aria-hidden="true"></span>
                        <span className="visually-hidden">Next</span>
                    </button>
                </div>
        </div>
        {/* For meta add start */}
        {/* <div className='result-googleAdwords container-fluid bg-primary  text-center pt-5 pb-2 mb-3'> */}
        <div className='result-googleAdwords container-fluid text-center pt-5 pb-2 mb-3' style={{ backgroundColor: '#0165E1' }}>

            <span className='fw-bolder head1'>Meta Ads Results <br /></span>
                <div id="MetaCarousel" className="carousel slide" data-bs-ride="carousel">
                    <div className="carousel-inner">
                        <div className="carousel-item active" data-bs-interval="2000">
                            <img src={carousel6} className="d-block w-100" alt="..."/>
                        </div>
                        <div className="carousel-item" data-bs-interval="2000">
                            <img src={carousel7} className="d-block w-100" alt="..."/>
                        </div>
                        <div className="carousel-item">
                            <img src={carousel8} className="d-block w-100" data-bs-interval="2000" alt="..."/>
                        </div>
                        <div className="carousel-item">
                            <img src={carousel9} className="d-block w-100" alt="..."/>
                        </div>
                    </div>
                    <button className="carousel-control-prev" type="button" data-bs-target="#MetaCarousel" data-bs-slide="prev">
                        <span className="carousel-control-prev-icon bg-dark" aria-hidden="true"></span>
                        <span className="visually-hidden">Previous</span>
                    </button>
                    <button className="carousel-control-next" type="button" data-bs-target="#MetaCarousel" data-bs-slide="next">
                        <span className="carousel-control-next-icon bg-dark" aria-hidden="true"></span>
                        <span className="visually-hidden">Next</span>
                    </button>
                </div>
        </div>
    </>
  );
}

export default Result;
